
import { Component, Vue } from 'vue-property-decorator'

@Component({ name: 'MonitorPage' })
export default class MonitorPage extends Vue {}
